import { BibliographyClass, CollectionFlag, Prefix } from '@/types'
import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'
import {
  dateTimeToDateFormat,
  dateTimeToPlainFormat,
  dateToPlainFormat
} from '@/utils'

export interface BrowseInsideCollection {
  collectionLendId: number
  userId: string
  bibliographyRealId: number
  collectionNo: string
  searchType: SystemCode
  bibliographyClass: BibliographyClass
  prefix: Prefix
  collectionFlag: CollectionFlag
  displayTitle: string
  sortTitle: string
  appendixCode: SystemCode
  collectionType: SystemCode
  shelfType: SystemCode
  lendTime: string
  dueDate: string
  placeCode: SystemCode
  revision: string
}

export function BrowseInsideCollectionFromJSON(
  json: any
): BrowseInsideCollection {
  return {
    collectionLendId: exists(json, 'collection_lend_id')
      ? json.collection_lend_id
      : 0,
    userId: exists(json, 'user_id') ? json.user_id : '',
    bibliographyRealId: exists(json, 'bibliography_real_id')
      ? json.bibliography_real_id
      : 0,
    collectionNo: exists(json, 'collection_no') ? json.collection_no : '',
    searchType: exists(json, 'search_type')
      ? SystemCodeFromJSON(json.search_type)
      : defaultSystemCode(),
    bibliographyClass: exists(json, 'bibliography_class')
      ? json.bibliography_class
      : BibliographyClass.Real,
    prefix: exists(json, 'prefix') ? json.prefix : Prefix.Real,
    collectionFlag: exists(json, 'collection_flag')
      ? json.collection_flag
      : CollectionFlag.NotCollection,
    displayTitle: exists(json, 'display_title') ? json.display_title : '',
    sortTitle: exists(json, 'sort_title') ? json.sort_title : '',
    appendixCode: exists(json, 'appendix_code')
      ? SystemCodeFromJSON(json.appendix_code)
      : defaultSystemCode(),
    collectionType: exists(json, 'collection_type')
      ? SystemCodeFromJSON(json.collection_type)
      : defaultSystemCode(),
    shelfType: exists(json, 'shelf_type')
      ? SystemCodeFromJSON(json.shelf_type)
      : defaultSystemCode(),
    lendTime: exists(json, 'lend_time')
      ? dateTimeToDateFormat(dateTimeToPlainFormat(json.lend_time))
      : '',
    dueDate: exists(json, 'due_date') ? dateToPlainFormat(json.due_date) : '',
    placeCode: exists(json, 'place_code')
      ? SystemCodeFromJSON(json.place_code)
      : defaultSystemCode(),
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
